import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ListOption } from '../../common/interfaces';

@Component({
    selector: 'select-option-dialog',
    templateUrl: './select-option-dialog.component.html',
    styleUrls: ['./select-option-dialog.component.css'],
    standalone: false
})
export class SelectOptionDialogComponent {
  title = '';
  public selectedOption: string;

  constructor(public dialogRef: MatDialogRef<SelectOptionDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: SelectOptionDialogModel) {
    const selected = data.listOptions.find((type) => type.selected === true);
    this.selectedOption = selected ? selected.value : data.listOptions[0].value;
    this.title = data.title;
  }

  onConfirm(): void {
    const dialogResult: SelectOptionDialogResult = { result: true, value: this.selectedOption };
    this.dialogRef.close(dialogResult);
  }

  onCancel(): void {
    const dialogResult: SelectOptionDialogResult = { result: false };
    this.dialogRef.close(dialogResult);
  }
}

export class SelectOptionDialogModel {
  constructor(public listOptions: ListOption[], public title: string) {
  }
}

export interface SelectOptionDialogResult {
  result: boolean;
  value?: string;
}
